import React, { useState } from 'react'
import './Login.css';
import logo from '../../assets/logo.png'
import { Navigate, NavLink } from 'react-router-dom';
function Login() {
    const [signState,setSignState]=useState("Sign Up");
    const validate=(event)=>{
        event.preventDefault();
        Navigate('/home')
    }
  return (
    <div className='login_page'>
        <div className='login-logo'>
            <img width="100" src={logo} alt='logo'/>
        </div>
        <div className='login'>
            <h2 className='login_heading'>{signState}</h2>
            <form onSubmit={validate}>
                <input className='form_input' type='text' placeholder='Enter Name'/>
                <input className='form_input' type='text' placeholder='Email'/>
                <input className='form_input' type='text' placeholder='Password'/>
                <NavLink to='/' type='submit' className='btn1'>{signState==="Sign Up"?"Sign In":"Register"}</NavLink>
            </form>
        <div className='below_form'>
            <div className='d-flex'>
                <input type='checkbox'/>
                <p className='m-0 ms-2'>Remember Me</p>
            </div>
            <p className='m-0'>Need Help</p>
        </div>
        {signState==="Sign Up"?
            <p className='alreadyAcc'>already have account? <span onClick={()=>setSignState("Sign In")}>Sign in Now</span></p>
            :
            <p className='alreadyAcc'>New to Netflix? <span onClick={()=>setSignState("Sign Up")}>Sign Up Now</span></p>
        }
        
        
        </div>
    </div>
  )
}

export default Login